/*----------------------------------------------------

	onload.js

----------------------------------------------------*/

/* carousel
----------------------------------------------------------------------------------------------------*/

var carouselInternal = '';
var carousel = document.querySelectorAll('.carousel');

[].forEach.call(carousel, function(this_carousel){

  if(this_carousel.children.length > 1){

    var transition = "2s";
    var delay = 7500;


    var carousel_slides = this_carousel.children;

    // create paging
    //var paging = document.createElement('ul');
    //paging.setAttribute('class','carousel-paging');
    paging = document.querySelector('#'+ this_carousel.dataset.paging);
    if(paging){
      var paging_links = '';
      for(i = 0; i < this_carousel.children.length; i++){
        paging_links += '<li><a href="#" data-num="' + i + '"><span class="screen-reader-text">' + i+1 + '</span></a></li>';
      }
      paging.innerHTML = paging_links;
      //insertAfter(document.querySelector('.banner--index__content'),paging);
      
      //var paging = document.querySelector('.carousel-paging');
      paging.querySelector('li:first-child a').classList.add('current');


      // paging click
      paging.querySelectorAll('a').forEach(function(item){
        item.addEventListener('click', function(e){
          e.preventDefault();
          var num = item.dataset.num;
          fadeCarousel(this_carousel, num);
          if(this_carousel.dataset.autoplay){
            clearInterval(carouselInternal); // clear autoplay
          }
        });
      });
    }


    // set first child as current
    carousel_slides[0].classList.add('current');

    // set slide opacity
    for(i = 1; i < this_carousel.children.length; i++){
      carousel_slides[i].style.opacity = '0';
    }

    if(this_carousel.dataset.autoplay){
      carouselInternal = setInterval(function(){

        // get next slide num
        curr_item = this_carousel.querySelector('.current');
        index = [...carousel_slides].indexOf(curr_item);
        num = (index == (this_carousel.children.length - 1)) ? 0 : index+1;

        // transition
        fadeCarousel(this_carousel, num);

      }, delay);
    }


    function fadeCarousel(this_carousel, num){

      // get current carousel
      var carousel_slides = this_carousel.children;
      var curr_item = this_carousel.querySelector('.current');

      // fade in
      carousel_slides[num].classList.add('current');
      carousel_slides[num].style.opacity = '1';
      carousel_slides[num].style.transition = "opacity " + transition + " ease";

      // fade out
      curr_item.classList.remove('current');
      curr_item.style.transition = "opacity " + transition + " ease";
      curr_item.style.opacity = '0';

      // update paging
      paging = document.querySelector('#'+ this_carousel.dataset.paging);
      if(paging){
        paging.querySelector('.current').classList.remove('current');
        paging.querySelectorAll('li')[num].querySelector('a').classList.add('current');
      }

    }

  }


  // swipe navigation
  let touchstartX = 0
  let touchendX = 0
      
  function checkDirection() {
    var swipedir = '';
    if (touchendX < touchstartX){
      swipedir = 'left';
    }else if(touchendX > touchstartX){
      swipedir = 'right';
    }

    curr_item = this_carousel.querySelector('.current');
    index = [...carousel_slides].indexOf(curr_item);

    if(swipedir == 'left'){
      num = (index == (this_carousel.children.length - 1)) ? 0 : index+1;
    }else{
      num = (index == 0) ? this_carousel.children.length - 1 : index-1;
    }

    fadeCarousel(this_carousel,num);
    if(this_carousel.dataset.autoplay){
      clearInterval(carouselInternal); // clear autoplay
    }

  }

  this_carousel.addEventListener('touchstart', e => {
    touchstartX = e.changedTouches[0].screenX
  })

  this_carousel.addEventListener('touchend', e => {
    touchendX = e.changedTouches[0].screenX
    checkDirection()
  })

});




/* scroller
---------------------------------------------------------------------------------------------------- */

function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

if(document.querySelectorAll('.projects-slider').length > 0){

  var slider_container = document.querySelector('.projects-slider');

  var wrapper = document.createElement('div');
  wrapper.setAttribute('class','projects-slider-wrap');
  wrap(slider_container, wrapper);

  var first_child = slider_container.querySelector('.projects__item:first-child');
  var scroll_amount = parseInt(getComputedStyle(first_child).minWidth);

  var icon = '<svg viewBox="0 0 100 100" class="icon icon-chevron-down"><use xlink:href="#chevron-down"></use></svg>';

  //var nav = document.createElement("div");
  //nav.setAttribute('class','projects-slider__nav');

  var prev = document.createElement("a");
  prev.setAttribute('class','projects-slider__nav__item projects-slider__nav__item--prev');
  prev.setAttribute('href','#');
  prev.innerHTML = icon + '<span class="screen-reader-text">Previous</span>';
  var next = document.createElement("a");
  next.setAttribute('class','projects-slider__nav__item projects-slider__nav__item--next');
  next.setAttribute('href','#');
  next.innerHTML = '<span class="screen-reader-text">Next</span>' + icon;
  slider_container.after(prev,next);


  var nav_links = document.querySelectorAll('.projects-slider__nav__item');
  [].forEach.call(nav_links, function(nl){

    nl.addEventListener('click', function(e){

      e.preventDefault();

      var direction = 'next';
      if(nl.classList.contains('projects-slider__nav__item--prev')){
        direction = 'prev';
      }

      if(direction == 'next'){
        slider_container.scrollLeft += scroll_amount;
      }else if(direction == 'prev'){
        slider_container.scrollLeft -= scroll_amount;
      }

    });

  });

}


/* livechat
---------------------------------------------------------------------------------------------------- */

var ua = navigator.userAgent.toLowerCase(), platform = navigator.platform.toLowerCase();
platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0],
isMobile = /ios|android|webos/.test(platformName);

if(document.querySelectorAll('body[data-haschat]').length > 0 && !isMobile){

  // insert zendesk chat script
  if(document.querySelectorAll('#zendesk-chat').length <= 0){ 
    window.$zopim||(function(d,s){var z=$zopim=function(c){z._.push(c)},$=z.s=d.createElement(s),e=d.getElementsByTagName(s)[0];z.set=function(o){z.set._.push(o)};z._=[];z.set._=[];$.async=!0;$.setAttribute("charset","utf-8");$.setAttribute("id","zendesk-chat");$.src="https://v2.zopim.com/?4VEz0hyrlLc28B3LK19xhZdF4uTYAaja";z.t=+new Date;$.type="text/javascript";e.parentNode.insertBefore($,e)})(document,"script");
  }


  $zopim(function(){

    $zopim.livechat.hideAll();

    var live_chat_btn_html = '<svg viewBox="0 0 100 100" class="icon icon-chat"><use xlink:href="#chat"></use></svg> <span class="screen-reader-text>Live Chat</span>';

    // create live chat link
    if(document.querySelectorAll('.live-chat').length <= 0){
      var chat_link = document.createElement("a");
      chat_link.setAttribute('class','live-chat');
      chat_link.setAttribute('href','#live-chat');
      chat_link.innerHTML = live_chat_btn_html;
      document.querySelectorAll('.the-footer')[0].after(chat_link);
    }
    

    // bind live chat links
    document.querySelectorAll('[href="#live-chat"]')[0].addEventListener('click', function(e){

      e.stopPropagation();
      e.preventDefault();

      console.log('chat link click');

      e.preventDefault();
      e.stopPropagation();
      if($zopim.livechat.window.getDisplay() == true){
        $zopim.livechat.window.hide();
      }else{
        $zopim.livechat.window.show();
      }

    });


    $zopim.livechat.window.onHide(function(){ // hides everything on close of window
      $zopim.livechat.hideAll();
    });
    

  });

}